// NOTE: NSAI-5117 — a one-way seam between the socket wiring and the background
// tracker, which would otherwise import each other.
//
// The shared WebSocketService needs to ask "is a reply still streaming?" before
// it cycles the handshake on a token refresh. Only the background tracker can
// answer that (it owns the tracked-chat set and reads the React Query cache),
// but the tracker itself needs the service. Routing the question through this
// module keeps the imports acyclic: the wiring reads the probe, the tracker
// installs it.
//
// Unset until the tracker module loads, which is exactly when a reply can be
// streaming — nothing can stream before the chat hook is mounted, and that hook
// pulls the tracker in.
let activeStreamProbe: (() => boolean) | null = null;

export const setActiveStreamProbe = (probe: () => boolean): void => {
  activeStreamProbe = probe;
};

export const hasActiveStreamProbe = (): boolean =>
  activeStreamProbe?.() ?? false;
